class CartNote extends HTMLElement {
  constructor() {
    super();
    this.textarea = this.querySelector("textarea");
    this.debouncedOnSubmit = debounce(() => this.onSubmit(), 750);

    this.textarea.addEventListener("input", this.debouncedOnSubmit.bind(this));
  }

  async onSubmit() {
    try {
      const response = await fetch(`${routes.cart_update_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ note: this.textarea.value }),
      });

      // Check if response is JSON before parsing
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();
        console.log("Cart note updated", data);
        // Add inside the .then() callback
        const successMsg = this.querySelector(".cart-note__success");
        successMsg.classList.add("active");
        setTimeout(() => successMsg.classList.remove("active"), 2000);
      } else {
        console.log("Cart note updated (non-JSON response)");
      }
    } catch (error) {
      console.error("Error updating cart note:", error);
    }
  }
}

customElements.define("cart-note", CartNote);
